<div class="opted-in-container">
  <div class="left">
    @if (customer.customerName) {
      <h3>{{customer.customerName}}</h3>
    }
  </div>
  <div class="right">
    <address>
      @if (customer.addr1) {
        <span>{{customer.addr1}}<br/></span>
      }
      @if (customer.addr2) {
        <span>{{customer.addr2}}<br/></span>
      }
      @if (customer.addr3) {
        <span>{{customer.addr3}}<br/></span>
      }
      @if (customer.city) {
        <span>{{customer.city}}</span>
        }, @if (customer.state) {
        <span>{{customer.state}}</span>
        }  @if (customer.postalCode) {
        <span>{{customer.postalCode}}</span>
        }<br />
        @if (customer.phone) {
          <span>{{customer.phone}}</span>
        }
      </address>
      <div class="opt-in">
        <button class="opt-in-btn" (click)="optIn()">Opt In</button>
      </div>
    </div>
  </div>